export default "{\n    \"chipLabel\": \"NEW\"\n}\n"